import { MutableRecordStore } from '@deqo/foundation';
import { Point } from '../../../platform/geom/Point';
import { Physical } from '../../canvas/entities/Physical';

const template = {
    target: null as Physical,
    drag: null as readonly [Point, Point],
};

export class HandControl extends MutableRecordStore(template) {

}
